const TARGET_PRODUCT_ID = 8949079638233;
const TWELVE_PACK_VARIANT_IDS = ["45759694799065", "48480199540953"];
const THREE_PACK_VARIANT_ID = 45759694733529;
const ENABLE_SUBSCRIPTION_GIFT = false;
const SUBSCRIPTION_PLAN_IDS = ["5914984665", "5915017433"];
const GIFT_PROPERTY_KEY = "_subscription_gift";
const GIFT_PROPERTY_VALUE = "true";

function normalizeFormPayload(form) {
  return JSON.parse(serializeForm(form));
}

function isEligibleSubscriptionAdd(payload) {
  const variantId = String(payload.id);
  const sellingPlanId = payload.selling_plan ? String(payload.selling_plan) : "";

  return (
    TWELVE_PACK_VARIANT_IDS.includes(variantId) &&
    SUBSCRIPTION_PLAN_IDS.includes(sellingPlanId)
  );
}

async function getCart() {
  const response = await fetch("/cart.js", {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch cart");
  }

  return response.json();
}

function giftedThreePackAlreadyInCart(cart) {
  return cart.items.some((item) => {
    const isThreePack = String(item.variant_id) === String(THREE_PACK_VARIANT_ID);
    const isGifted =
      item.properties &&
      String(item.properties[GIFT_PROPERTY_KEY]) === GIFT_PROPERTY_VALUE;

    return isThreePack && isGifted;
  });
}

async function addToCartWithSubscriptionGift(form) {
  const payload = normalizeFormPayload(form);

  const items = [
    {
      id: payload.id,
      quantity: Number(payload.quantity || 1),
      ...(payload.selling_plan ? { selling_plan: payload.selling_plan } : {}),
      ...(payload.properties ? { properties: payload.properties } : {}),
    },
  ];

  if (ENABLE_SUBSCRIPTION_GIFT && isEligibleSubscriptionAdd(payload)) {
    const cart = await getCart();

    if (!giftedThreePackAlreadyInCart(cart)) {
      items.push({
        id: THREE_PACK_VARIANT_ID,
        quantity: 1,
        properties: {
          [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE,
          _gift_source: "12-pack-subscription",
          _linked_variant: String(payload.id),
          _linked_product: String(TARGET_PRODUCT_ID),
        },
      });
    }
  }

  const response = await fetch(`${routes.cart_add_url}`, {
    ...fetchConfig("javascript"),
    body: JSON.stringify({ items }),
  });

  if (!response.ok) {
    throw new Error("Failed to add item(s) to cart");
  }

  return response.text();
}

async function refreshCartDrawer(cartDrawer) {
  const response = await fetch(`/?section_id=hd--global--cart-drawer`);
  const state = await response.text();
  cartDrawer.renderContents(state);
}

class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    let uspsSlider = document.querySelector('.page--product_usps_points_slider');
    if (uspsSlider) {
      let splide_usps = new Splide(uspsSlider, {
        perPage: 1,
        pagination: false,
        arrows: true,
        drag: false,
      }).mount();
    }

    let splide = new Splide(".component--product--media__slider", {
      pagination: true,
      arrows: false,
      perPage: 1,
      focus: 'center',
      gap: '8px',
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 1,
          pagination: true,
        }
      }
    });

    let thumbnails = document.getElementsByClassName(
      "component--product--media__thumbnail"
    );
    let current;

    for (let i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }

    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener("click", function () {
        splide.go(index);
      });
    }

    splide.on("mounted move", function () {
      let thumbnail = thumbnails[splide.index];
      if (thumbnail) {
        if (current) {
          current.classList.remove("is-active");
        }
        thumbnail.classList.add("is-active");
        current = thumbnail;
      }
    });

    splide.mount();
  }
}
customElements.define("product-media-slider", ProductMediaSlider);

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.bar = this.querySelector(".component--product--sticky-bar");
    this.footer = document.querySelector(".footer");
    this.productForm = document.querySelector("product-form");
    this.cart = document.querySelector("cart-drawer");
    this.bindEvents();
    this.toggle.bind(this);
  }

  bindEvents() {
    document.addEventListener("scroll", this.toggle.bind(this));
    document
      .querySelector(".component--product--sticky-bar__button")
      .addEventListener("click", this.onSubmitHandler.bind(this));
  }

  async onSubmitHandler() {
    const submitButton = this.productForm.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);

    try {
      await addToCartWithSubscriptionGift(this.productForm.form);
      await refreshCartDrawer(this.cart);
    } catch (e) {
      console.error(e);
    } finally {
      submitButton.removeAttribute("disabled");
    }
  }

  inViewport(el) {
    const rect = el.getBoundingClientRect();
    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    const vHeight = window.innerHeight || document.documentElement.clientHeight;
    const efp = function (x, y) {
      return document.elementFromPoint(x, y);
    };

    if (
      rect.right < 0 ||
      rect.bottom < 0 ||
      rect.left > vWidth ||
      rect.top > vHeight
    ) {
      return false;
    }

    return (
      el.contains(efp(rect.left, rect.top)) ||
      el.contains(efp(rect.right, rect.top)) ||
      el.contains(efp(rect.right, rect.bottom)) ||
      el.contains(efp(rect.left, rect.bottom))
    );
  }

  toggle() {
    const visible = this.inViewport(this.productForm.form);
    if (
      visible ||
      this.inViewport(document.querySelector(".component--product--wrapper"))
    ) {
      this.classList.remove("component--product--sticky-bar--active");
      this.footer.removeAttribute("style");
    } else {
      this.classList.add("component--product--sticky-bar--active");
      this.footer.style.marginBottom = this.offsetHeight + "px";
    }
  }
}
customElements.define("product-sticky-bar", ProductStickyBar);

class ProductFAQ extends HTMLElement {
  constructor() {
    super();
    this.accordions = document.querySelectorAll(
      ".component--product--faq--question"
    );
    this.bindEvents();
  }

  bindEvents() {
    this.accordions.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleAccordion.bind(this))
    );
  }

  toggleAccordion(event) {
    const element = event.currentTarget;
    element.classList.toggle("component--product--faq--question--active");
    this.accordions.forEach((accordion) => {
      if (accordion !== element) {
        accordion.classList.remove("component--product--faq--question--active");
      }
    });
  }
}
customElements.define("product-faq", ProductFAQ);

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".component--product--ugc--slider")) {
    const splide = new Splide(".component--product--ugc--slider", {
      type: "loop",
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: false,
      gap: "24px",
      breakpoints: {
        600: {
          perPage: 1,
          gap: "16px",
          padding: "100px",
          pagination: true,
        },
      },
    }).mount();

    const videoWrappers = document.querySelectorAll(
      ".page--product--media__video-wrapper"
    );

    if (videoWrappers.length > 0) {
      videoWrappers.forEach((video, index) => {
        video.addEventListener("click", (e) => {
          videoWrappers.forEach((video, i) => {
            if (index != i) {
              video.querySelector("video").muted = true;
              video.querySelector(
                ".page--product--media__play-btn"
              ).style.display = "block";
              video.querySelector("video").pause();
              video.querySelector("video").currentTime = 0;
            } else {
              if (video.querySelector("video").muted != true) {
                video.querySelector(
                  ".page--product--media__play-btn"
                ).style.display = "block";
                video.querySelector("video").pause();
                video.querySelector("video").currentTime = 0;
                video.querySelector("video").muted = true;
              } else {
                video.querySelector("video").currentTime = 0;
                video.querySelector("video").play();
                video.querySelector(
                  ".page--product--media__play-btn"
                ).style.display = "none";
                video.querySelector("video").muted = false;
              }
            }
          });
        });
      });
    }
  }

  if (document.querySelector(".page--product--about__media-wrapper")) {
    const videoWrapper = document.querySelector(
      ".page--product--about__media-wrapper"
    );
    const button = document.querySelector(".page--product--about__play");
    const buttonWrapper = document.querySelector(
      ".page--product--about__play-btn"
    );

    buttonWrapper.addEventListener("click", (e) => {
      videoWrapper.querySelector("video").currentTime = 0;
      videoWrapper.querySelector("video").play();
      buttonWrapper.style.display = "none";
      videoWrapper.querySelector("video").muted = false;
    });

    videoWrapper.querySelector("video").addEventListener("click", (e) => {
      buttonWrapper.style.display = "block";
      videoWrapper.querySelector("video").muted = true;
    });
  }
});

class RefillSubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this.onetime = document.querySelector("#product-recharge-selector__once");
    this.subscription = document.querySelector(
      "#product-recharge-selector__recurring"
    );
    this.isSubscription = false;
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      this.onetime.addEventListener("click", this.selectOneTime.bind(this));
      this.subscription.addEventListener(
        "click",
        this.selectSubscription.bind(this)
      );
      document
        .querySelector(".product-recharge-selector__options")
        .addEventListener("change", this.selectSubscription.bind(this));
    });
  }

  onChange() {
    this.updateForm();
    if (this.option.value == "true") {
      this.selectSubscription();
    } else {
      this.selectOneTime();
    }
  }

  updateButton(price) {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    addButtons.forEach((addButton) => {
      const qty = addButton.querySelector('[name="quantity"]').value;
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      const total = JSON.parse(price) * JSON.parse(qty);
      addButton.setAttribute("data-product-price", price);
      addButton.textContent =
        window.variantStrings.addToCart + " — $" + formatMoney(total);
    });
  }

  selectOneTime() {
    this.isSubscription = false;
    this.querySelector(".product-recharge-selector__mode--once").classList.add(
      "product-recharge-selector__mode--active"
    );
    this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).classList.remove("product-recharge-selector__mode--active");
    this.querySelector(
      ".product-recharge-selector__option-wrapper"
    ).classList.remove("product-recharge-selector__option-wrapper--active");
    this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).style.borderTop = "none";
    this.querySelector(
      ".product-recharge-selector__mode--once"
    ).style.borderBottomWidth = "1px";
    this.querySelector(
      ".product-recharge-selector__mode--once"
    ).style.borderBottomStyle = "solid";

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const ele = productForm.querySelector('input[name="selling_plan"]');
      if (ele) ele.remove();
    });

    const price = this.querySelector(
      ".product-recharge-selector__mode--once"
    ).getAttribute("data-price");

    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    addButtons.forEach((addButton) => {
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.addToCart + " — $" + price;
    });

    if (document.querySelector(".component--product--sticky-bar__button")) {
      document.querySelector(
        ".component--product--sticky-bar__button"
      ).textContent = window.variantStrings.addToCart + " — $" + price;
    }
  }

  selectSubscription() {
    this.isSubscription = true;
    document
      .querySelector(".product-recharge-selector__mode--once")
      .classList.remove("product-recharge-selector__mode--active");
    document
      .querySelector(".product-recharge-selector__mode--recurring")
      .classList.add("product-recharge-selector__mode--active");
    this.querySelector(
      ".product-recharge-selector__option-wrapper"
    ).classList.add("product-recharge-selector__option-wrapper--active");
    this.querySelector(
      ".product-recharge-selector__mode--once"
    ).style.borderBottom = "none";
    this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).style.borderTopWidth = "1px";
    this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).style.borderTopStyle = "solid";

    this.updateOptions();

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      if (productForm.querySelector('input[name="selling_plan"]')) {
        productForm
          .querySelector('input[name="selling_plan"]')
          .setAttribute("value", this.plan.value);
      } else {
        let input = document.createElement("input");
        input.type = "hidden";
        input.setAttribute("name", "selling_plan");
        input.setAttribute("value", this.plan.value);
        productForm.appendChild(input);
      }
    });

    const price = document
      .querySelector(".product-recharge-selector__mode--recurring")
      .getAttribute("data-price");
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    addButtons.forEach((addButton) => {
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.addToCart + " — $" + price;
    });

    if (document.querySelector(".component--product--sticky-bar__button")) {
      document.querySelector(
        ".component--product--sticky-bar__button"
      ).textContent = window.variantStrings.addToCart + " — $" + price;
    }
  }

  updateSubscription() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      productForm
        .querySelector('input[name="selling_plan"]')
        .setAttribute("value", this.plan.value);
    });
  }

  updateOptions() {
    this.plan = Array.from(
      this.querySelectorAll(".product-recharge-selector__frequency-input")
    ).find((radio) => radio.checked);

    Array.from(
      this.querySelectorAll(".product-recharge-selector__frequency-input")
    ).find((radio) => {
      if (this.plan.value == radio.value) {
        radio.checked = true;
        radio.setAttribute("checked", "");
      } else {
        radio.checked = false;
        radio.removeAttribute("checked");
      }
    });
  }

  updateForm() {
    this.option = Array.from(
      this.querySelectorAll(".product-recharge-selector__mode-input")
    ).find((radio) => radio.checked);

    Array.from(
      this.querySelectorAll(".product-recharge-selector__mode-input")
    ).find((radio) => {
      if (this.option.value == radio.value) {
        radio.checked = true;
        radio.setAttribute("checked", "");
      } else {
        radio.checked = false;
        radio.removeAttribute("checked");
      }
    });
  }
}
customElements.define(
  "refill-subscription-selector",
  RefillSubscriptionSelector
);

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);

    try {
      await addToCartWithSubscriptionGift(this.form);
      await refreshCartDrawer(this.cart);
    } catch (e) {
      console.error(e);
    } finally {
      submitButton.removeAttribute("disabled");
    }
  }
}
customElements.define("product-form", ProductForm);

class ProductDropdown extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(
      ".component--product--dropdown__titles"
    );
    this.accordions = document.querySelectorAll(
      ".component--product--dropdown__titles"
    );
    console.log(this.accordions);
    this.bindEvents();
  }

  bindEvents() {
    this.accordion.addEventListener("click", this.toggleAccordion.bind(this));
  }

  toggleAccordion(event) {
    const element = event.currentTarget;
    element.classList.toggle("component--product--dropdown__titles--active");
    this.accordions.forEach((accordion) => {
      if (accordion !== element) {
        accordion.classList.remove(
          "component--product--dropdown__titles--active"
        );
      }
    });
  }
}
customElements.define("product-dropdown", ProductDropdown);

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.getVariantData.bind(this);
    /*
    const button = document.querySelector("[data-waitlist-button]");
    button.addEventListener("click", () => {
      if (window.innerWidth < 768) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["openForm", "WvH6FV"]);
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["openForm", "QWrFEt"]);
      }
    });
    */
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateQuantity();
    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      if (!this.closest('.featured--product--details--new')) {
        this.updateURL();
      }
      this.renderProductInfo();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateQuantity() {
    const var_cls = '.pws_var' + this.currentVariant.id;
    console.log('act_var: ', var_cls);
    const targetElement = document.querySelector(var_cls);
  }

  setUnavailable() {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      addButton.disabled = true;
    });
    document.querySelector(
      ".component--product--sticky-bar__button"
    ).textContent = window.variantStrings.unavailable;
    document.querySelector(
      ".component--product--sticky-bar__button"
    ).style.pointerEvents = "none";
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const mediaSource = html.getElementById(
          "page--product--product__content"
        );
        const mediaD = document.getElementById(
          "page--product--product__content"
        );
        PropsMarquee && PropsMarquee.resumeAfterDomReplace();

        mediaD.innerHTML = mediaSource.innerHTML;

        requestAnimationFrame(() => {
          PropsMarquee && PropsMarquee.resumeAfterDomReplace();

          if (window.initSubscriptionWidget) {
            window.initSubscriptionWidget();
          }
        });
      });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-selector", VariantSelector);

window.PropsMarquee = (function () {
  let raf;
  let scroller, track;
  let position = 0;
  const speed = 0.25;
  let paused = false;

  function bindHover() {
    scroller.onmouseenter = () => paused = true;
    scroller.onmouseleave = () => paused = false;
  }

  function cloneOnce() {
    if (track.dataset.cloned) return;
    const items = Array.from(track.children);
    items.forEach(el => {
      const clone = el.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    });
    track.dataset.cloned = "true";
  }

  function animate() {
    if (!paused) {
      position -= speed;
      const half = track.scrollWidth / 2;
      if (Math.abs(position) >= half) position += half;
      track.style.transform = `translateX(${position}px)`;
    }
    raf = requestAnimationFrame(animate);
  }

  function init(resumeRatio = null) {
    scroller = document.querySelector('.props-value-scroller');
    if (!scroller) return;

    track = scroller.querySelector('.props-value-track');
    if (!track) return;

    cancelAnimationFrame(raf);

    cloneOnce();
    bindHover();

    if (resumeRatio !== null) {
      const half = track.scrollWidth / 2;
      position = -half * resumeRatio;
    }

    animate();
  }

  function getProgress() {
    if (!track) return 0;
    const half = track.scrollWidth / 2;
    return Math.abs(position) / half;
  }

  return {
    start() {
      init();
    },
    resumeAfterDomReplace() {
      const ratio = getProgress();
      requestAnimationFrame(() => init(ratio));
    }
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  PropsMarquee.start();
});

// document.addEventListener('click', function (e) {
//   const trigger = e.target.closest('.pia__trigger');

//   if (!trigger) return;

//   const item = trigger.closest('.pia__item');
//   const container = trigger.closest('.pia');

//   container.querySelectorAll('.pia__item').forEach(i => {
//     i.classList.remove('pia__item--open');
//     i.querySelector('.pia__trigger')?.setAttribute('aria-expanded', 'false');
//     i.querySelector('.pia__body-wrap').style.gridTemplateRows = '0fr';
//   });

//   if (!item.classList.contains('pia__item--open')) {
//     item.classList.add('pia__item--open');
//     trigger.setAttribute('aria-expanded', 'true');
//     item.querySelector('.pia__body-wrap').style.gridTemplateRows = '1fr';
//   }
// });
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.pia__trigger');

  if (!trigger) return;

  const item = trigger.closest('.pia__item');
  const container = trigger.closest('.pia');
  const isOpen = item.classList.contains('pia__item--open');

  if (isOpen) {
    item.classList.remove('pia__item--open');
    trigger.setAttribute('aria-expanded', 'false');
    item.querySelector('.pia__body-wrap').style.gridTemplateRows = '0fr';
    return;
  }

  container.querySelectorAll('.pia__item').forEach(i => {
    i.classList.remove('pia__item--open');
    i.querySelector('.pia__trigger')?.setAttribute('aria-expanded', 'false');
    i.querySelector('.pia__body-wrap').style.gridTemplateRows = '0fr';
  });

  item.classList.add('pia__item--open');
  trigger.setAttribute('aria-expanded', 'true');
  item.querySelector('.pia__body-wrap').style.gridTemplateRows = '1fr';
});


document.addEventListener('DOMContentLoaded', () => {
  const featuredVariantSelector = document.querySelector(
    '.featured--product--details--new variant-selector'
  );

  if (!featuredVariantSelector) return;

  const sixPackInput = [...featuredVariantSelector.querySelectorAll('input[type="radio"]')]
    .find(input => input.value === '6 Pack');

  if (!sixPackInput) return;

  if (!sixPackInput.checked) {
    sixPackInput.checked = true;
    sixPackInput.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
});